import { request } from "./http";

export interface QRCode {
  id: number;
  suffix: string;
  target_url: string;
  clicks: number;
  created_at: string;
  updated_at: string;
}

export const createQRCode = (targetUrl: string) =>
  request<QRCode>("/api/qr-codes", {
    method: "POST",
    body: JSON.stringify({ target_url: targetUrl }),
  });

export function getQRCodeUrl(suffix: string): string {
  return `${window.location.origin}/q/${suffix}`;
}
